<template>
  <div>
    <div class="medium col-xs-6 col-sm-4 col-md-3 col-lg-3" v-for="(medium, index) in media" :key="index">
      <video :src="mediumPath(medium.fileName)" preload="metadata" controls controlsList="nodownload"></video>
      <div class="buttons">
        <button class="btn btn-success" @click="makeActive(medium.id)" v-if="!medium.active">Make active</button>
        <button class="btn btn-primary" @click="uploadToKiosks(medium.id)" v-if="!medium.uploaded">Upload <i class="fa fa-upload"></i></button>
        <button class="btn btn-danger" @click="deleteMedium(medium.id)" v-if="!medium.active"><i class="fa fa-trash"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'media',
  data () {
    return {
      media: []
    }
  },
  methods: {
    mediumPath (fileName) {
      return this.$store.state.api + 'media/' + fileName
    },
    deleteMedium (id) {
      let self = this
      let reply = confirm('Czy na pewno chcesz usunąć medium?')
      if (reply) {
        this.$http.post('mediumKfc/delete', {id: id})
          .then(response => {
            return response.json()
          }, response => {
            // TODO handle error - show
            self.$notify('Błąd: ' + response.status + ' ' + response.statusText, 'error')
          })
          .then(data => {
            self.$notify('Wysłano komendę usunięcia', 'success')
            console.log('deleteMedium', data)
          })
      }
    },
    makeActive (id) {
      let self = this
      let reply = confirm('Czy na pewno chcesz aktywować medium?')
      if (reply) {
        this.$http.post('mediumKfc/activate', {id: id})
          .then(response => {
            return response.json()
          }, response => {
            // TODO handle error - show
            self.$notify('Błąd: ' + response.status + ' ' + response.statusText, 'error')
          })
          .then(data => {
            self.$notify('Wysłano komendę aktywacji', 'success')
            console.log('makeActive', data)
          })
      }
    },
    uploadToKiosks (id) {
      let self = this
      let reply = confirm('Czy na pewno chcesz wgrać medium na Kioski?')
      if (reply) {
        this.$http.post('mediumKfc/uploadToKiosk', {id: id})
          .then(response => {
            return response.json()
          }, response => {
            // TODO handle error - show
            self.$notify('Błąd: ' + response.status + ' ' + response.statusText, 'error')
          })
          .then(data => {
            self.$notify('Wysłano komendę aktualizacji', 'success')
            console.log('uploadToKiosks', data)
          })
      }
    }
  },
  beforeCreate () {
    this.$http.get('mediumKfc')
      .then(response => {
        return response.json()
      })
      .then(data => {
        const resultArray = []
        for (let key in data) {
          resultArray.push(data[key])
        }
        this.showLoader = false
        this.media = resultArray
      })
  }
}
</script>

<style lang="sass">
.medium
  min-height: 194px
  margin-bottom: 20px

  video
    width: 100%
    height: 150%

  .buttons
    display: flex
    justify-content: space-between
</style>



// WEBPACK FOOTER //
// src/components/media/MediaList.vue